module.exports = __webpack_public_path__ + "static/mobile-918771a56c106667c27beadf1328c73a.jpg";